export default __webpack_public_path__ + "static/media/dash-incoming.7e8a07fb.svg";